import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalCellularConnectedNoInternet0Bar = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M10.667 4.444v9.778H.889zm3.555 8v1.778h-1.778v-1.778zm0-6.222v4.445h-1.778V6.222zm0-5.333v3.555h-3.555z"
      />
    </g>
  </svg>
)
export default SvgSignalCellularConnectedNoInternet0Bar
